import { useTranslation, Trans } from 'react-i18next'
import { showTrustScoreInfoModal } from './base'
import InfoIcon from './info-icon'
import social from './images/social.png'

const SocialVerification = props => {
  const { t } = useTranslation()
  return (
    <InfoIcon
      {...props}
      onClick={() =>
        showTrustScoreInfoModal({
          title: t('b.liv_score.view.social_verification.title', 'Social Verification'),
          description: (
            <Trans i18nKey="b.liv_score.view.social_verification.text">
              <strong>Social Verification</strong> is determined through an automatic check of the
              renter's name on liv.rent against the name listed on the LinkedIn account attached to
              their profile.
            </Trans>
          ),
          image: social
        })
      }
    />
  )
}

export default SocialVerification
